import { EntityState } from '@ngrx/entity';
import { ITransaction, ITransactionActionType } from 'src/app/models/transactions';
import { transactionAdapter } from 'src/app/store/transactions/selectors/transactions.selectors';
import { ClientEntity } from 'src/app/models/clients';
import { IPagingInfo, initialPagingInfo } from 'src/app/models/pagingInfo';
import { AccountType } from 'src/app/models/account';

export interface ITransactionsState extends EntityState<ITransaction> {
    error: string;
    loading: boolean;
    toDate: Date;
    fromDate: Date;
    clientEntityIds: ClientEntity[];
    pagingInfo: IPagingInfo;
    transactionActionType: ITransactionActionType;
    portfolioTransactionType: AccountType;
}

export interface ITransactionStates {
    cash: ITransactionsState,
    securities: ITransactionsState,
    revenue: ITransactionsState
}

export const initialTransactionsState = transactionAdapter.getInitialState({
    error: '',
    loading: true,
    toDate: null,
    fromDate: null,
    clientEntityIds: [],
    portfolioTransactionType: null,
    transactionActionType: null,
    pagingInfo: {
        ...initialPagingInfo,
        sortOrder: "Date",
        pageSize: 100
    }
});

export const initialTransactionStates = {
    cash: initialTransactionsState,
    securities: initialTransactionsState,
    revenue: initialTransactionsState
} as ITransactionStates